import { Radio } from 'antd'
import React from 'react'

import './YearSwitcher.css'

const YearSwitcher = ({ year, onYearChange, years = ['2025', '2026'] }) => {
  return (
    <div className='year-switcher'>
      <Radio.Group value={year} onChange={onYearChange}>
        {years.map(year => (
          <Radio.Button key={year} value={year}>
            <i className='icon-calendar' />
            {year}
          </Radio.Button>
        ))}
      </Radio.Group>
    </div>
  )
}

export default YearSwitcher
